import React, { useMemo } from "react"

import { FilterChip } from "@/components/common/Filters"
import type { PriceChangeFilterInput } from "@/graphql/codegen/graphql"
import useProductClassification from "@/screens/ManageProducts/components/ProductClasses/hooks/useProductClassification"

interface ClassFilterChipsProps {
  selectedClass?: string
  onRemove: (key: keyof PriceChangeFilterInput, value?: string) => void
}

const ClassFilterChips: React.FC<ClassFilterChipsProps> = ({ selectedClass, onRemove }) => {
  const { productClassList } = useProductClassification({
    query: "",
    ...(selectedClass && selectedClass?.length && { classIds: [selectedClass] }),
  })

  const className = useMemo(
    () => productClassList.find((productClass) => productClass.classificationId === selectedClass)?.name ?? "",
    [selectedClass, productClassList]
  )

  return (
    <FilterChip
      key={`price-change-product-class-filter-chip`}
      label={`Product Class: ${className}`}
      onDelete={() => onRemove("productClassId", undefined)}
    />
  )
}

export default ClassFilterChips
